export default "__VITE_ASSET__e7f55643__"